// extracted by mini-css-extract-plugin
export default {"FeelLikeIconJoy":"FeelLike_FeelLikeIconJoy__-veHu","FeelLikeIconMeh":"FeelLike_FeelLikeIconMeh__Fewj5","FeelLikeIconSad":"FeelLike_FeelLikeIconSad__MPmyg"};